module.exports = __webpack_public_path__ + "translations/en/register.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/register.json
// module id = ./translations/en/register.json
// module chunks = 1